export class CityDistrictModel {
    constructor(public id: string, public name: string, public province_id: string){}
}